import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-resource-unit-filter',
  templateUrl: './resource-unit-filter.component.html',
  styleUrls: ['./resource-unit-filter.component.scss']
})
export class ResourceUnitFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listResourceUnitFilter: any[];
  optionSelected: any;

  @Input() resourceUnitData: any;
  @Input() resourceUnitSelected: ResourcesUnitModel;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges (changes: SimpleChanges) {
    if ('resourceUnitData' in changes) {
      this.listResourceUnitFilter = this.resourceUnitData;
      this.optionSelected = null;
    }
    if (this.resourceUnitSelected) {
      this.optionSelected = this.resourceUnitSelected;
    }
  }

  ngOnDestroy(): void {
  }
}
